export default "__VITE_ASSET__DuqgiI1v__"